import PropTypes from 'prop-types'
import React from 'react'
import classes from './Customers.scss'
import Button from 'components/Button'
import List from 'components/BetterList'

import { formatCityState } from 'helpers/components'

export class Customers extends React.Component {
  getRowLink = customer => {
    return `/customers/${customer.id}/edit`
  };

  getRowColumns = (customer, index, array) => {
    return [
      customer.name,
      formatCityState(customer.city, customer.state)
    ]
  };

  render () {
    return (
      <div className={classes['collection']}>
        <header className={classes['header']}>
          <div className={classes['header-title']}>
            Browsing Customers
            <span className={classes['header-title--unimportant']}> – {this.props.customers.length}</span>
          </div>

          <div className={classes['header-buttons']}>
            <Button options={['green', 'small']} element='a' href='/customers/new'>
              Add Customer
            </Button>
          </div>
        </header>

        <List
          collection={this.props.customers}
          headers={['name', 'location']}

          getRowLink={this.getRowLink}
          getRowColumns={this.getRowColumns}

          sort={'name'}
          filter={[
            'name', 'contacts[].name', 'contacts[].phone_number', 'contacts[].email'
          ]}
          filterPlaceholder='search customers'
        />
      </div>
    )
  }
}

Customers.propTypes = {
  customers: PropTypes.array.isRequired
}

Customers.defaultProps = {
  customers: []
}

export default Customers



// WEBPACK FOOTER //
// ./src/components/Customers/Customers.js